module.exports = __webpack_public_path__ + "static/img/hg.d334e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/hg.png
// module id = ub2d
// module chunks = 1